import { ReactNode } from 'react';

import { cn } from '@client/lib';

interface DataRowProps {
  label: string;
  children: ReactNode;
  helperText?: string;
  highlight?: 'red' | 'green' | null;
  className?: string;
}

export function DataRow({ label, highlight, children, helperText, className }: DataRowProps) {
  return (
    <div className={cn('flex items-center justify-between', className)}>
      <span className="text-sm text-gray-700">{label}</span>
      <div
        className={cn({
          'text-right': helperText,
        })}
      >
        <span
          className={cn('text-sm font-medium capitalize text-gray-950', {
            'text-red-600': highlight === 'red',
            'text-green-600': highlight === 'green',
          })}
        >
          {children}
        </span>
        {helperText && <p className="mt-0.5 text-xs text-gray-700">{helperText}</p>}
      </div>
    </div>
  );
}
